import React, { useContext, useState } from "react";

import {
  Grid,
  //   ContentCut,
  Box,
  ListItemText,
  Typography,
  AppBar,
  Toolbar,
  List,
  ListItem,
  ListItemButton,
  Button,
  LinearProgress,
  Avatar,
} from "@mui/material";
import AuthContext from "../../store/auth/auth-context";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SeatsContext from "../../store/seats/seats-context";
import SupportForm from "./support-form";
import Cart from "./cart";
import useHttp from "../../hooks/use-http";

const TopBarNavigation = () => {
  const authCxt = useContext(AuthContext);
  const seatsCxt = useContext(SeatsContext);
  const [formOpenState, setFormOpenState] = useState(false);
  const [cartOpenState, setCartOpenState] = useState(false);
  const [supportForState, setSupportForState] = useState("Upgrade");

  const supportHandler = (data: any) => {
    // console.log("click Contact")
    setFormOpenState(true);
  };

  const cartHandler = (data: any) => {
    // console.log("click Contact")
    setCartOpenState(true);
  };

  const documentationHandler = () => {
    window.open("https://senseops.com/resources/documentation/");
  };

  const supportFreshworkHandler = () => {
    window.open(
      // "https://senseopsinc-help.freshdesk.com/support/tickets/new"
      "https://senseopsinc.myfreshworks.com/login/auth/1716378335843?client_id=451980303908285122&redirect_uri=https%3A%2F%2Fsenseopsinc-help.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Dsenseopsinc-help.freshdesk.com"
      // https://senseopsinc-help.freshdesk.com/support/home
    );
  };

  // const additionalWidth = authCxt.userInfo?.isVarified===false ? 40 : 0;
  const drawerWidth = 240;

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: `calc(100% - ${drawerWidth}px)`,
          ml: `${drawerWidth}px`,
          boxShadow: 0,
          backgroundColor: "#F9F9F9",
        }}
      >
        <Toolbar
          sx={{ paddingLeft: "0px !important", paddingRight: "0px !important" }}
        >
          <SupportForm
            supportFor={supportForState}
            openState={formOpenState}
            setFormOpenState={setFormOpenState}
          />
          <Cart
            prevSeats={seatsCxt.availableSeats}
            accountEmail={authCxt.userInfo?.email}
            supportFor={supportForState}
            openState={cartOpenState}
            setCartOpenState={setCartOpenState}
            setFormOpenState={setFormOpenState}
          />
          <Grid display={"flex"} flexDirection={"column"} width={"100%"}>
            {!authCxt.userInfo?.isVarified && !authCxt.authLoading ? (
              <Grid
                container
                width={"100%"}
                p={0}
                m={0}
                sx={{ backgroundColor: "#FFF2CD", height: "35px" }}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Grid item>
                  <InfoOutlinedIcon
                    fontSize={"inherit"}
                    sx={{ color: "#F47907", fontSize: "14px" }}
                  />
                </Grid>
                <Grid item pl={1}>
                  <Typography
                    variant="body2"
                    sx={{ color: "#F47907", fontSize: "13px" }}
                  >
                    Your account is pending verification. Please authorise with
                    registered email address.
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            <Grid
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              width={"100%"}
              pl={4}
              pr={4}
            >
              <Grid item xs={7} container spacing={1} alignItems={"center"}>
                <Grid item xs="auto">
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ fontSize: "24px" }}
                  >
                    All Products
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography sx={{ width: "140px", ml: 3 }}>
                    {!authCxt.userInfo?.isVarified ? (
                      <LinearProgress
                        variant="determinate"
                        value={0}
                        color={"inherit"}
                      />
                    ) : (
                      <LinearProgress
                        variant="determinate"
                        value={
                          (seatsCxt.consumedSeats / seatsCxt.availableSeats) *
                          100
                        }
                      />
                    )}
                  </Typography>
                </Grid>

                {authCxt.userInfo?.isVarified && !authCxt.authLoading ? (
                  <Grid item xs display={"flex"} alignItems={"center"}>
                    <Box>
                      <Typography
                        variant="body2"
                        component="span"
                        color={"#FF8D24"}
                      >
                        <Avatar
                          src="/assets/icons/Seats-icon.svg"
                          sx={{
                            fontSize: "10px",
                            width: "25px",
                            height: "25px",
                            color: "#FF8D24",
                          }}
                          // color={primary}
                        />
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        variant="body2"
                        component="div"
                        color={"#8D8D8D"}
                      >
                        <Typography
                          variant="body2"
                          component="span"
                          color={"#FF8D24"}
                        >
                          {seatsCxt.consumedSeats}
                        </Typography>
                        / {seatsCxt.availableSeats} Users
                      </Typography>
                    </Box>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>

              <Grid display={"flex"} item xs={5}>
                <List
                  sx={{ display: "flex", flexDirection: "row", padding: 0 }}
                >
                  {/* {["Documentation", "Support"].map((text, index) => ( */}
                  <ListItem key={"Documentation"} disablePadding>
                    <ListItemButton sx={{ py: 0 }}>
                      <ListItemText
                        onClick={documentationHandler}
                        primary={"Documentation"}
                        primaryTypographyProps={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#3A3A3A",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                  <ListItem key={"Support"} disablePadding>
                    {/* //onClick={()=>supportHandler({ supportFor: "Global support" })} */}
                    <ListItemButton sx={{ py: 0 }}>
                      <ListItemText
                        onClick={supportFreshworkHandler}
                        primary={"Raise ticket"}
                        primaryTypographyProps={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#3A3A3A",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>

                  <ListItem disablePadding>
                    <Button
                      disabled={
                        !authCxt.userInfo?.isVarified ||
                        (seatsCxt.availableSeats > 10 &&
                          seatsCxt.subscriptionStatus === false)
                      }
                      // onClick={() =>
                      //   cartHandler({ supportFor: "Upgrade support" })
                      // }
                      onClick={()=>supportHandler({ supportFor: "Upgrade support"})}

                      variant="contained"
                      sx={{
                        ml: 3,
                        mb: 0,
                        width: "110px",
                        bgcolor: "#F47907",
                        fontSize: "11px",
                        "&.Mui-disabled": {
                          background: "#f6d9b9",
                        },
                        "&:hover": {
                          bgcolor: "#FF8D24",
                        },
                      }}
                    >
                      Upgrade plan
                    </Button>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default TopBarNavigation;
